import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=5c5a7cb4&scoped=true"
import script from "./UiSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=5c5a7cb4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a7cb4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/components/ui/UiIcon.vue').default})
